/** Batch photo cap for free/Premium users. */
export const BATCH_IMAGE_LIMIT_DEFAULT = 50
/** Batch photo cap for Super users. */
export const BATCH_IMAGE_LIMIT_SUPER = 1000

export function getMaxBatchImages(isSuper: boolean): number {
  return isSuper ? BATCH_IMAGE_LIMIT_SUPER : BATCH_IMAGE_LIMIT_DEFAULT
}
